import useSelector from '@hooks/useSelector'

import filterPriceListItemOptionsByItem from '../functions/filterPriceListItemOptionsByItem'

type UseProductOptionsSelectorOptions = {
  selectedProviderPriceListItemId: number,
}

function useProductOptionsSelector(options: UseProductOptionsSelectorOptions) {
  const { selectedProviderPriceListItemId } = options

  const entities = useSelector(reduxState => reduxState.entities)
  const {
    providerPriceListItems,
    providerPriceListItemOptions,
    providerPriceListItemOptionValues,
  } = entities

  const filteredProviderPriceListItemOptions = filterPriceListItemOptionsByItem({
    providerPriceListItem: providerPriceListItems[selectedProviderPriceListItemId],
    providerPriceListItemOptions,
  })

  return {
    filteredProviderPriceListItemOptions,
    providerPriceListItemOptionValues,
  }
}

export default useProductOptionsSelector
